// Dev-only logger: silences console output in production builds while
// preserving diagnostics locally. Console access is intentionally gated
// by NODE_ENV; the eslint-disable comments below make that explicit.
const isDev = process.env.NODE_ENV !== "production";

/* eslint-disable no-console */
export const logger = {
  error: (...args) => { if (isDev) console.error(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
};
/* eslint-enable no-console */

export default logger;
